module.exports = __webpack_public_path__ + "img/logo.5e3b7e1e.svg";